import { PaymentMethodType } from '@nemuru-eng/js-api-client';

import { AbstractPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/_shared/entities/PaymentMethod/AbstractPaymentMethod';
import { SinglePaymentMethod } from '@/components/modules/Application/components/PaymentMethod/_shared/entities/PaymentMethod/SinglePaymentMethod';
import { AutoLoanPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/AutoLoan/entities/PaymentMethod/AutoLoanPaymentMethod';
import { B2BLoanPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/B2BLoan/entities/PaymentMethod/B2BLoanPaymentMethod';
import { BnplPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/Bnpl/entities/PaymentMethod/BnplPaymentMethod';
import { CardOnboardingPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/CardOnboarding/entities/PaymentMethod/CardOnboardingPaymentMethod';
import { ConsumerLoanPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/ConsumerLoan/entities/PaymentMethod/ConsumerLoanPaymentMethod';
import { CreditLinePaymentMethod } from '@/components/modules/Application/components/PaymentMethod/CreditLine/entities/PaymentMethod/CreditLinePaymentMethod';

const PaymentMethods = [
  BnplPaymentMethod,
  CardOnboardingPaymentMethod,
  ConsumerLoanPaymentMethod,
  AutoLoanPaymentMethod,
  CreditLinePaymentMethod,
  SinglePaymentMethod,
  B2BLoanPaymentMethod,
];

export class PaymentMethodFactory {
  public static byType(paymentMethodType: PaymentMethodType): AbstractPaymentMethod | void {
    for (const PaymentMethod of PaymentMethods) {
      const paymentMethod = new PaymentMethod(paymentMethodType);
      if (paymentMethod.isPaymentMethodTypeAllowed(paymentMethodType)) {
        return paymentMethod;
      }
    }
  }
}
